export default {
  solicitarLinkRecuperacionClave(persona) {
    return new Promise((resolve, reject) => {
      let ruta = `/traslado/personas/password/email`;
      return axios.post(ruta, persona).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      });
    })
  },
  asignarNuevaClave(persona) {
    return new Promise((resolve, reject) => {
      let ruta = `/traslado/personas/password/new`;
      return axios.post(ruta, persona).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      });
    })
  }
}


